
export const AuthSortides = ({ auth, handleChange, error }) => {
  return (<>
    <div className="row">
    <div className="col col-12 ">
      <h4>
      Autorització per a realitzar activitats fora del centre
      </h4>
      <p>
        <input type="checkbox" id="authSortides" name="authSortides" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
        <label htmlFor="authSortides">
          AUTORITZO que el meu fill/a es desplaci fora del Centre per realitzar les excursions i activitats que l’institut programi fora del recinte escolar durant tot el curs.
            </label>
        <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
      </p>

    </div>
  </div>

    <br />
  </>)
}
